import PropTypes from 'prop-types'
import { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { I18n, Translate } from 'react-redux-i18n'
import { UseTheme } from '../../hooks/useTheme'
import { UseTypeFontSize } from '../../hooks/useTypeFontSize'
import { Style } from '../Style'
import { Element } from '../element'
import { getStyle } from '../helper'
import classes from './index.module.scss'

export const InputTextArea = ({
  value,
  containerStyle,
  inputRef,
  placeHolder,
  style,
  onClick,
  onBlur,
  onChange,
  onKeyDown,
  isShowLabel,
  rows,
  isRequired,
  isValid,
  textInvalid,
  readOnly,
  defaultValue,
  suggestionBtns,
}) => {
  const typeFontSize = UseTypeFontSize()
  const theme = UseTheme()
  const locale = useSelector((state) => state.i18n.locale)

  const [borderColor, setBorderColor] = useState('#E0E0E0')
  const [text, setText] = useState(defaultValue)
  const [isFocus, setIsFocus] = useState(false)

  const getPlaceHolder = useMemo(() => {
    return isShowLabel && isFocus ? '' : I18n.t(placeHolder)
  }, [locale, placeHolder, isShowLabel, isFocus])

  const onHandleClick = (event) => {
    setBorderColor('#2C73E8')
    onClick(event)
    setIsFocus(true)
  }

  const onHandleBlur = (event) => {
    setBorderColor('#E0E0E0')
    onBlur(event)
    setIsFocus(false)
  }

  const onHandleChange = (event) => {
    setText(event.target.value)
    onChange(event)
  }

  useEffect(() => {
    if (value !== undefined) {
      setText(value)
    }
  }, [value])

  return (
    <div ref={inputRef} className={classes.container} style={containerStyle}>
      <Style
        className={classes.textarea}
        pseudo=":placeholder"
        attr="color"
        color="#9c9c9c"
      >
        <textarea
          value={text}
          className={classes.textarea}
          placeholder={getPlaceHolder}
          rows={rows}
          onClick={onHandleClick}
          onBlur={onHandleBlur}
          onKeyDown={onKeyDown}
          onChange={onHandleChange}
          readOnly={readOnly}
          style={getStyle(
            {
              ...style,
              fontSize: 14,
              borderColor,
            },
            theme,
            typeFontSize,
          )}
        />
      </Style>
      {isShowLabel && (isFocus || text) && placeHolder && (
        <Element
          elementName="span"
          style={{
            backgroundColor: '#F3F3F3',
            padding: '2px 4px',
            left: 6,
            top: -14,
          }}
          className="fw600 positionAbsolute"
        >
          <Translate value={placeHolder} />
          {isRequired && (
            <Element elementName="span" style={{ color: '#E0505B' }}>
              *
            </Element>
          )}
        </Element>
      )}
      {!isValid && (
        <Element
          elementName="span"
          style={{ left: 0, bottom: -16, color: '#E0505B' }}
          className="positionAbsolute"
        >
          <Translate value={textInvalid} />
        </Element>
      )}
      {suggestionBtns && (
        <Element
          elementName="span"
          style={{ left: 0, bottom: 6, marginLeft: 6 }}
          className="positionAbsolute"
        >
          {suggestionBtns}
        </Element>
      )}
    </div>
  )
}

InputTextArea.propTypes = {
  ref: PropTypes.object,
  placeHolder: PropTypes.string,
  style: PropTypes.object,
  rows: PropTypes.number,
  onClick: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func,
  onChange: PropTypes.func,
  isShowLabel: PropTypes.bool,
  isValid: PropTypes.bool,
  textInvalid: PropTypes.string,
}

InputTextArea.defaultProps = {
  placeHolder: '',
  rows: 5,
  style: {},
  onClick: () => {},
  onBlur: () => {},
  onChange: () => {},
  onKeyDown: () => {},
  isShowLabel: false,
  textInvalid: '',
  isValid: true,
  defaultValue: '',
}
